import React from "react";
import "./Footer.scss";

const Footer = () => {
  return (
    <footer className="main-footer">
      <div className="footer-t">
        <p>Jennifer chioma</p>
      </div>
    </footer>
  );
};

export default Footer;
